export const fxpTenantConfiguration =  tenantConfiguration;